import React from 'react'
import styled from 'styled-components'
import { data } from './data'
import { PointForts } from './PointForts'

const PointsFortsContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 32px;
  padding: 24px 16px 48px 16px;
  background-color: #253163;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);

  @media (min-width: 601px) {
    flex-direction: row;
    align-items: flex-start;
    gap: 60px;
    box-shadow: none;
  }

  @media (min-width: 721px) {
    row-gap: 16px;
  }

  @media (min-width: 965px) {
    padding: 24px 32px 48px 32px;
  }

  @media (min-width: 997px) {
    padding: 64px 32px 64px 32px;
  }
`

export const PointsForts = () => (
  <PointsFortsContainer>
    {data.map(props => (
      <PointForts key={props.title} {...props} />
    ))}
  </PointsFortsContainer>
)
